import { connect } from 'react-redux'
import { isAllowedAccessToFeature, selectCurrentInbox } from 'ducks/billing'

import AuthorizeModalView from './View'

const select = state => ({
  inboxPlan: selectCurrentInbox(state),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    ...{
      isAllowedAccessToFeature: isAllowedAccessToFeature(
        stateProps.inboxPlan,
        ownProps.feature
      ),
    },
  }
}

export default connect(select, null, mergeProps)(AuthorizeModalView)
